// Rahaty Store — High-Performance Conversion & Multi-Pixel Tracking Engine
(function(window, document) {
  'use strict';

  window.RahatyPixels = window.RahatyPixels || {};

  const DEFAULT_TIKTOK_PIXEL_ID = 'CMLVVQRC77UDUQCEL31G';
  const DEFAULT_SNAPCHAT_PIXEL_ID = '6acab76a-fc98-41da-a75a-e96410169595';
  const DEFAULT_META_PIXEL_ID = '1541768904393736';

  function getTikTokPixelId() {
    return window.RAHATY_SETTINGS?.tiktokPixelId || DEFAULT_TIKTOK_PIXEL_ID;
  }

  function getSnapchatPixelId() {
    return window.RAHATY_SETTINGS?.snapchatPixelId || DEFAULT_SNAPCHAT_PIXEL_ID;
  }

  function getMetaPixelId() {
    return window.RAHATY_SETTINGS?.metaPixelId || DEFAULT_META_PIXEL_ID;
  }

  // Trigger deferred external scripts when critical events occur
  function ensureExternalScripts() {
    if (typeof window.loadExternalTrackingScripts === 'function') {
      try { window.loadExternalTrackingScripts('conversion'); } catch (e) {}
    }
  }

  // Safeguard: Ensure TikTok pixel is initialized
  function ensureTikTokPixel(forceLoadScript) {
    const pixelId = getTikTokPixelId();
    if (!pixelId) return;
    if (forceLoadScript === 'conversion') {
      ensureExternalScripts();
    }
    if (!window.ttq) {
      window.TiktokAnalyticsObject = 'ttq';
      var ttq = window.ttq = window.ttq || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
      ttq.setAndDefer = function (t, e) {
        t.rd_e = e;
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e) {
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date;
        ttq._o = ttq._o || {};
      };
      ttq.load(pixelId);
      ttq.enableCookie();
      ttq.page();
    }
  }

  ensureTikTokPixel(false);

  // Safeguard: Ensure Snapchat pixel is initialized
  function ensureSnapchatPixel(forceLoadScript) {
    const pixelId = getSnapchatPixelId();
    if (!pixelId) return;
    if (forceLoadScript === 'conversion') {
      ensureExternalScripts();
    }
    if (!window.snaptr) {
      var a = window.snaptr = function() {
        a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
      };
      a.queue = [];
      window.snaptr('init', pixelId);
    }
  }

  ensureSnapchatPixel(false);

  // Safeguard: Ensure Meta Pixel is initialized
  function ensureMetaPixel(forceLoadScript) {
    const pixelId = getMetaPixelId();
    if (!pixelId) return;
    if (forceLoadScript === 'conversion') {
      ensureExternalScripts();
    }
    if (!window.fbq) {
      var n = window.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      window.fbq('init', pixelId);
    }
  }

  ensureMetaPixel(false);

  // Helper: Format phone number into standard E.164 format (+971...)
  function formatPhoneE164(phone) {
    if (!phone) return '';
    let cleaned = String(phone).trim().replace(/[^\d+]/g, '');
    if (cleaned.startsWith('00')) {
      cleaned = '+' + cleaned.substring(2);
    }
    if (!cleaned.startsWith('+')) {
      if (cleaned.startsWith('05') && cleaned.length === 10) {
        cleaned = '+971' + cleaned.substring(1);
      } else if (cleaned.startsWith('5') && cleaned.length === 9) {
        cleaned = '+971' + cleaned;
      } else if (cleaned.startsWith('971')) {
        cleaned = '+' + cleaned;
      } else {
        cleaned = '+' + cleaned;
      }
    }
    return cleaned;
  }

  // Advanced Matching: Identify user across platforms
  function identifyUser(userData) {
    if (!userData) return;
    const phone = formatPhoneE164(userData.phone);
    const name = (userData.name || '').trim();

    ensureTikTokPixel();

    // 1. TikTok Advanced Matching
    if (window.ttq && typeof window.ttq.identify === 'function') {
      try {
        const identifyPayload = {};
        if (phone) identifyPayload.phone_number = phone;
        if (name) identifyPayload.name = name;
        window.ttq.identify(identifyPayload);
      } catch (err) {
        console.warn('Error identifying TikTok user:', err);
      }
    }

    // 2. Snapchat Advanced Matching
    ensureSnapchatPixel();
    if (typeof window.snaptr === 'function') {
      try {
        const snapPayload = {};
        const digitsPhone = phone.replace(/[^\d]/g, '');
        if (digitsPhone) snapPayload.user_phone_number = digitsPhone;
        if (userData.email) snapPayload.user_email = userData.email.trim().toLowerCase();
        if (Object.keys(snapPayload).length > 0) {
          window.snaptr('init', getSnapchatPixelId(), snapPayload);
        }
      } catch (err) {
        console.warn('Error identifying Snapchat user:', err);
      }
    }
  }

  // Core Conversion Tracker: Fired immediately on checkout submit or thank-you page
  function trackOrderConversion(orderData, eventId, source, forceFire) {
    if (!orderData) return;

    const isTest = forceFire || window.location.search.includes('test') || window.location.hash.includes('test');
    const effectiveEventId = eventId || sessionStorage.getItem('rahaty_event_id') || ('EVT-' + Date.now());
    const orderKey = orderData.orderId || effectiveEventId;

    // Strict Deduplication Check: Guarantee purchase event fires exactly ONCE per order (bypassed in test mode or forceFire)
    if (!isTest && sessionStorage.getItem('rahaty_order_purchased_' + orderKey) === 'true') {
      console.log('ℹ️ [RahatyPixels] Purchase event already fired for this order:', orderKey);
      return;
    }
    sessionStorage.setItem('rahaty_order_purchased_' + orderKey, 'true');

    try {
      ensureExternalScripts();
      const value = parseFloat(orderData.totalPrice) || 0;
      const skus = orderData.sku ? String(orderData.sku).split('/').map(s => s.trim()) : [];
      const products = orderData.product ? String(orderData.product).split('/').map(p => p.trim()) : [];
      const quantities = orderData.quantity ? String(orderData.quantity).split('/').map(q => parseInt(q.trim()) || 1) : [1];

      const contents = [];
      let totalQty = 0;
      for (let i = 0; i < (products.length || 1); i++) {
        const qty = quantities[i] || 1;
        totalQty += qty;
        contents.push({
          content_id: skus[i] || ('RH-' + (orderData.orderId || 'ORDER')),
          content_name: products[i] || orderData.product || '',
          content_type: 'product',
          quantity: qty,
          price: (products.length > 0 ? (value / products.length).toFixed(2) : value)
        });
      }
      if (totalQty === 0) totalQty = 1;

      // Identify user for advanced matching
      identifyUser(orderData);

      // 1. TikTok Pixel Multi-Event Conversion Tracking
      ensureTikTokPixel();
      if (window.ttq && typeof window.ttq.track === 'function') {
        const ttPurchasePayload = {
          content_id: skus[0] || ('RH-' + (orderData.orderId || 'ORDER')),
          content_name: orderData.product || 'Rahaty Order',
          content_type: 'product',
          quantity: totalQty,
          price: value,
          value: value,
          currency: 'AED',
          contents: contents
        };

        const ttOptions = { event_id: effectiveEventId };

        // A. Standard Purchase event
        window.ttq.track('Purchase', ttPurchasePayload, ttOptions);

        // B. Standard CompletePayment event (historically/widely used in TikTok Ads campaigns)
        window.ttq.track('CompletePayment', ttPurchasePayload, ttOptions);

        // C. Standard SubmitForm event (specifically for lead-gen / COD forms)
        window.ttq.track('SubmitForm', {
          content_name: orderData.product ? ('COD Order - ' + orderData.product) : 'COD Order Form',
          content_id: orderData.orderId || effectiveEventId,
          value: value,
          currency: 'AED'
        }, ttOptions);

        // D. Standard CompleteRegistration event (specifically for lead campaigns)
        window.ttq.track('CompleteRegistration', {
          content_name: 'COD Customer Lead',
          content_id: orderData.orderId || effectiveEventId,
          value: value,
          currency: 'AED'
        }, ttOptions);

        // E. PlaceAnOrder event (for backwards compatibility)
        window.ttq.track('PlaceAnOrder', ttPurchasePayload, ttOptions);
        console.log('✅ [TikTok Pixel] Purchase & CompletePayment fired successfully:', ttPurchasePayload);
      }

      // 2. Meta (Facebook) Pixel Tracking
      ensureMetaPixel();
      if (typeof window.fbq === 'function') {
        const metaPurchasePayload = {
          value: value,
          currency: 'AED',
          content_ids: skus.length > 0 ? skus : [orderData.sku || ('RH-' + (orderData.orderId || 'ORDER'))],
          content_name: orderData.product || '',
          content_type: 'product',
          order_id: orderData.orderId,
          num_items: totalQty
        };
        window.fbq('track', 'Purchase', metaPurchasePayload, { eventID: effectiveEventId });
        window.fbq('track', 'Lead', {
          value: value,
          currency: 'AED',
          content_name: orderData.product || 'COD Order Lead'
        }, { eventID: effectiveEventId });
        console.log('✅ [Meta Pixel] Purchase & Lead fired successfully:', metaPurchasePayload);
      }

      // 3. Snapchat Pixel Tracking
      ensureSnapchatPixel();
      if (typeof window.snaptr === 'function') {
        const snapPixelId = getSnapchatPixelId();
        if (snapPixelId) {
          try {
            window.snaptr('init', snapPixelId);
          } catch(e) {}
        }
        const snapPurchasePayload = {
          price: value,
          currency: 'AED',
          transaction_id: orderData.orderId || effectiveEventId,
          client_dedup_id: effectiveEventId,
          item_ids: skus.length > 0 ? skus : [orderData.sku || ('RH-' + (orderData.orderId || 'ORDER'))],
          number_items: totalQty
        };
        window.snaptr('track', 'PURCHASE', snapPurchasePayload);
        console.log('✅ [Snapchat Pixel] PURCHASE fired successfully:', snapPurchasePayload);
      }

      // Mark conversion as fired to eliminate duplicate tracking in the same session
      sessionStorage.setItem('rahaty_conversion_fired_' + orderKey, 'true');
      sessionStorage.setItem('rahaty_purchase_pixel_fired', 'true');
      sessionStorage.setItem('rahaty_last_order', JSON.stringify(orderData));
      sessionStorage.setItem('rahaty_event_id', effectiveEventId);

    } catch (e) {
      console.error('Error in trackOrderConversion:', e);
    }
  }

  // Backward-compatible firePurchase
  function firePurchase(orderDataParam, eventIdParam, force) {
    if (orderDataParam) {
      trackOrderConversion(orderDataParam, eventIdParam, 'direct_call', force);
      return;
    }
    let orderDataRaw = sessionStorage.getItem('rahaty_last_order');
    const isTest = force || window.location.search.includes('test') || window.location.hash.includes('test');
    if (!orderDataRaw && isTest) {
      const testOrder = {
        orderId: 'TEST-' + Math.floor(Date.now() / 1000),
        name: 'عميل تجريبي',
        phone: '+971501234567',
        product: 'حزام Belty الأصلي لتخفيف آلام ومغص الدورة الشهرية والظهر',
        totalPrice: '119.95',
        quantity: '1',
        sku: 'RH-BELTY-01'
      };
      orderDataRaw = JSON.stringify(testOrder);
      sessionStorage.setItem('rahaty_last_order', orderDataRaw);
    }
    const eventId = sessionStorage.getItem('rahaty_event_id') || ('EVT-' + Date.now());
    if (orderDataRaw) {
      try {
        const orderData = JSON.parse(orderDataRaw);
        trackOrderConversion(orderData, eventId, 'thank_you_session', isTest);
      } catch (err) {
        console.error('Error parsing orderData for firePurchase:', err);
      }
    }
  }

  // PageView
  function firePageView() {
    ensureMetaPixel();
    if (typeof window.fbq === 'function' && getMetaPixelId()) {
      window.fbq('track', 'PageView');
    }
    ensureTikTokPixel();
    if (window.ttq && typeof window.ttq.page === 'function') {
      window.ttq.page();
    }
    ensureSnapchatPixel();
    if (typeof window.snaptr === 'function' && getSnapchatPixelId()) {
      // Avoid duplicate Page View: Shopify Web Pixels Manager already runs the official Snapchat app
      const isShopifyWebPixelActive = Boolean(
        document.querySelector('script[src*="web-pixels-manager"]') ||
        window.webPixelsManager ||
        window.Shopify?.analytics
      );
      if (!isShopifyWebPixelActive) {
        window.snaptr('track', 'PAGE_VIEW');
      }
    }
  }

  // ViewContent
  function fireViewContent() {
    const title = document.querySelector('meta[property="og:title"]')?.content || document.title;
    const price = parseFloat(document.querySelector('meta[property="og:price:amount"]')?.content) || 0;
    const sku = document.querySelector('meta[property="product:retailer_item_id"]')?.content || document.querySelector('input[name="id"]')?.value || '';

    ensureMetaPixel();
    if (typeof window.fbq === 'function' && getMetaPixelId()) {
      window.fbq('track', 'ViewContent', {
        content_name: title,
        content_ids: [sku],
        content_type: 'product',
        value: price,
        currency: 'AED'
      });
    }
    ensureTikTokPixel();
    if (window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track('ViewContent', {
        content_id: sku,
        content_type: 'product',
        content_name: title,
        value: price,
        currency: 'AED'
      });
    }
    ensureSnapchatPixel();
    if (typeof window.snaptr === 'function' && getSnapchatPixelId()) {
      window.snaptr('track', 'VIEW_CONTENT', {
        price: price,
        currency: 'AED',
        item_ids: [sku]
      });
    }
  }

  // AddToCart
  function fireAddToCart(name, sku, value) {
    ensureExternalScripts();
    ensureMetaPixel();
    if (typeof window.fbq === 'function' && getMetaPixelId()) {
      window.fbq('track', 'AddToCart', {
        content_name: name,
        content_ids: [sku],
        content_type: 'product',
        value: value,
        currency: 'AED'
      });
    }
    ensureTikTokPixel();
    if (window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track('AddToCart', {
        content_id: sku,
        content_type: 'product',
        content_name: name,
        value: value,
        currency: 'AED'
      });
    }
    ensureSnapchatPixel();
    if (typeof window.snaptr === 'function' && getSnapchatPixelId()) {
      window.snaptr('track', 'ADD_CART', {
        price: value,
        currency: 'AED',
        item_ids: [sku]
      });
    }
  }

  // InitiateCheckout
  function fireInitiateCheckout(skus, value) {
    ensureExternalScripts();
    ensureMetaPixel();
    if (typeof window.fbq === 'function' && getMetaPixelId()) {
      window.fbq('track', 'InitiateCheckout', {
        content_ids: skus,
        content_type: 'product',
        value: value,
        currency: 'AED'
      });
    }
    ensureTikTokPixel();
    if (window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track('InitiateCheckout', {
        content_id: skus[0] || '',
        content_type: 'product',
        value: value,
        currency: 'AED'
      });
    }
    ensureSnapchatPixel();
    if (typeof window.snaptr === 'function' && getSnapchatPixelId()) {
      window.snaptr('track', 'START_CHECKOUT', {
        price: value,
        currency: 'AED',
        item_ids: skus
      });
    }
  }

  // Expose on window
  window.RahatyPixels.identifyUser = identifyUser;
  window.RahatyPixels.trackOrderConversion = trackOrderConversion;
  window.RahatyPixels.firePurchase = firePurchase;
  window.RahatyPixels.firePageView = firePageView;
  window.RahatyPixels.fireViewContent = fireViewContent;
  window.RahatyPixels.fireAddToCart = fireAddToCart;
  window.RahatyPixels.fireInitiateCheckout = fireInitiateCheckout;
  window.firePurchase = firePurchase;

  // DOMContentLoaded handlers
  document.addEventListener('DOMContentLoaded', () => {
    firePageView();

    if (window.location.pathname.includes('/products/') || document.body.classList.contains('template-product') || document.querySelector('product-form')) {
      fireViewContent();
    }

    // Support multiple cart add event signatures (custom LP sections + native theme)
    const handleCartAdd = (event) => {
      try {
        const cart = event.detail?.resource;
        const items = event.detail?.items || event.detail?.detail?.items || [];
        if (items.length > 0) {
          const first = items[0];
          const name = first.product_title || first.title || '';
          const sku = first.sku || first.id || '';
          const val = first.price ? (parseFloat(first.price) / 100) : 0;
          fireAddToCart(name, sku, val);
          return;
        }
        const addedId = event.detail?.sourceId;
        let addedItem = null;
        if (cart && cart.items && addedId) {
          addedItem = cart.items.find(item => item.variant_id.toString() === addedId.toString());
        }
        if (addedItem) {
          const val = addedItem.price ? (addedItem.price / 100) : 0;
          fireAddToCart(addedItem.product_title, addedItem.sku || addedId, val);
        }
      } catch (e) {
        console.error('Error firing AddToCart pixel event:', e);
      }
    };

    document.addEventListener('cart:update', handleCartAdd);
    document.addEventListener('cart-update', handleCartAdd);
    document.addEventListener('cart:updated', handleCartAdd);

    // COD Checkout Modal open -> InitiateCheckout
    const codModal = document.querySelector('#cod-checkout-modal');
    if (codModal) {
      codModal.addEventListener('dialog:open', () => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const val = cart.total_price / 100;
            const skus = cart.items.map(item => item.sku || item.variant_id);
            fireInitiateCheckout(skus, val);
          })
          .catch(err => console.error('Error fetching cart for InitiateCheckout:', err));
      });
    }

    // Thank You page detection (robust path check & DOM check)
    if (window.location.pathname.includes('/pages/thank-you') || document.querySelector('.thank-you-section')) {
      firePurchase();
    }
  });

})(window, document);
